/**
 * @file 页脚数据
 * @author wanzhongyun
 */

export interface IFooterDataItem {
    name: string,
    url: string,
    target?: string
}

export interface IFooterDataGroup {
    groupName: string,
    list: IFooterDataItem[],
}

const footerData: IFooterDataGroup[] = [
    {
        groupName: 'Products',
        list: [
            {
                name: 'PaddleHub',
                url: 'https://github.com/PaddlePaddle/PaddleHub',
                target: '_blank'
            },
            {
                name: 'Paddle Lite',
                url: 'https://github.com/PaddlePaddle/Paddle-Lite',
                target: '_blank'
            },
            {
                name: 'ERNIEKit',
                url: 'https://github.com/PaddlePaddle/ERNIE',
                target: '_blank'
            },
            {
                name: 'More',
                url: 'https://github.com/PaddlePaddle',
                target: '_blank'
            }
        ]
    },
    {
        groupName: 'Resources',
        list: [
            {
                name: 'Install',
                url: '/en/install/quick?docurl=/documentation/docs/en/install/pip/macos-pip_en.html'
            },
            {
                name: 'Documents',
                url: '/documentation/docs/en/guides/index_en.html',
            },
            {
                name: 'Customers',
                url: '/en/customercase'
            }
        ]
    },
    {
        groupName: 'Links',
        list: [
            {
                name: 'Baidu Brain',
                url: 'https://ai.baidu.com/',
                target: '_blank'
            },
            {
                name: 'AI Studio',
                url: 'https://aistudio.baidu.com/',
                target: '_blank'
            },
            {
                name: 'EasyDL',
                url: 'http://ai.baidu.com/easydl/',
                target: '_blank'
            },
            {
                name: 'BML',
                url: 'https://ai.baidu.com/bml/',
                target: '_blank'
            },
            {
                name: 'Developer',
                url: 'https://developer.baidu.com/',
                target: '_blank'
            }
        ]
    },
    {
        groupName: 'Contact',
        list: [
            {
                name: 'GitHub',
                url: 'http://github.com/paddlepaddle/paddle',
                target: '_blank'
            },
            {
                name: 'Email',
                url: 'mailto:Paddle-better@baidu.com'
            },
            {
                name: 'Gitee',
                url: 'https://gitee.com/paddlepaddle',
                target: '_blank'
            },
            {
                name: 'GitCode',
                url: 'https://gitcode.com/paddlepaddle',
                target: '_blank'
            }
        ]
    }
];

export default footerData;
